<template>
  <v-container>
    <h2>Next Steps:</h2>

    <div class="next-steps-grid">
      <div
        v-for="(item, index) in steps"
        :key="item.logo"
        class="img-wrapper"
        :style="{ order: itemOrder('logo', index) }">
        <img :src="item.logo" alt="" />
      </div>

      <h3
        v-for="(item, index) in steps"
        :key="item.title"
        :style="{ order: itemOrder('title', index) }">
        {{ item.title }}
      </h3>

      <template v-if="$vuetify.breakpoint.lgAndUp">
        <p
          v-for="(item) in steps"
          :key="'text-' + item.title">
          {{ item.description }}
        </p>
      </template>
    </div>
  </v-container>
</template>

<script>
import imageMoneyBag from '@/modules/user/assets/money_bag.png'
import imagePhone from '@/modules/user/assets/phone.png'
import imageShoppingCart from '@/modules/user/assets/shopping_cart.png'

export default {
  name: 'NextSteps',
  data: () => ({
    steps: [
      {
        title: 'Review your lender options',
        description:
          'Now that you\'ve been matched you can view what set each lender apart and which will be best for your loan',
        logo: imagePhone,
      },
      {
        title: 'Pick your lender(s)',
        description:
          'You can select 1 or all lenders that you would like to contact you',
        logo: imageShoppingCart,
      },
      {
        title: 'Get Financed',
        description:
          'Your chosen lender(s) will contact you regarding your loan eligibility',
        logo: imageMoneyBag,
      },
    ],
  }),
  methods: {
    itemOrder (type, index) {
      if (this.$vuetify.breakpoint.lgAndUp) return 0

      if (type === 'logo') return 2 * index
      if (type === 'title') return (2 * index) + 1
      return 0
    },
  },
}
</script>

<style lang="scss" scoped>
.container {
  margin-top: 50px;
  background-color: white;

  h2 {
    color: $textDarkMuted;
    text-align: center;

    @include lg { text-align: left; }
  }
}

.next-steps-grid {
  margin-top: 45px;

  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: auto;
  grid-column-gap: 5%;
  grid-row-gap: 18px;

  @include lg {
    grid-template-columns: 1fr 1fr 1fr;
    grid-template-rows: 1fr;
  }

  text-align: center;

  .img-wrapper {
    height: 130px;
    width: 130px;
    margin: auto;
    background-color: #C6F2F7A0;
    border-radius: 50%;

    display: flex;
    align-items: center;
    justify-content: center;

    img {
      height: 65px;
      width: 65px;
    }
  }

  h3 {
    margin-bottom: 15px;

    color: $secondaryBlue;
    font-size: 16px;
    line-height: 22px;

    @include md {
      font-size: 24px;
      line-height: 36px;
    }

    @include lg { margin-bottom: 0; }

  }

  p {
    order: 0;
    padding: 0 40px;

    color: $textGrey;
    font-family: "Avenir Book", sans-serif;
    line-height: 24px;
  }
}
</style>
